import React, { PropsWithChildren, useContext } from 'react'
import { ERefreshProfile } from '../../components/Page/ProfileSettings/type'

export type TState = {
    resumeId: number
    isOpenToWork: boolean
    statusRefresh: ERefreshProfile
    expiredDate: string
    isTurnOnRefresh: boolean
}

export type TStore = {
    state: TState
    setState: React.Dispatch<React.SetStateAction<TState>>
}
export const iniStore: TStore = {
    state: {
        resumeId: 0,
        isOpenToWork: false,
        statusRefresh: ERefreshProfile.Unset,
        expiredDate: '',
        isTurnOnRefresh: false
    },
    setState: () => {}
}
const Context = React.createContext<TStore>(iniStore)

const ProfileSettingProvider = ({ children, state, setState }: PropsWithChildren<TStore>) => {
    return <Context.Provider value={{ state, setState }}>{children}</Context.Provider>
}

const useProfileSettingStore = () => useContext(Context)

export { useProfileSettingStore, ProfileSettingProvider }
